import createVueApp from '@/common/create_app'

Styxie.Initializers.MlapSettingsGscGa4 = {
  show: async(props) => {
    const { default: GscGa4Settings } = await import('@/vue_widgets/mlap/settings/gsc_ga4/index.vue')
    createVueApp(GscGa4Settings, { props })
  }
}
